import { BaseMutations } from '@/store/base-mutations';
import {
  CartHistoryItem, FiltersOrganization, HistroyCartsFilters, UsersFilter,
} from '../../../types';
import CartState from './state';

export default class CartHistoryMutations extends BaseMutations<CartState> {
  SET_CART_HISTORY_ITEMS(items: CartHistoryItem[]) {
    this.state.history_carts_list = items;
  }

  SET_CART_HISTORY_ORGANIZATION(organizations: FiltersOrganization) {
    this.state.organizations = organizations;
  }

  SET_CART_HISTORY_DATES(dates: string[]) {
    this.state.allowed_dates = dates;
  }

  SET_USERS(users: UsersFilter[]) {
    this.state.users = users;
  }

  UPD_FILTER_KEY({ key, value }: { key: keyof HistroyCartsFilters, value: unknown }) {
    this.state.filters[key] = value;
  }

  TOGGLE_LOADING_HISTORY(toggle: boolean) {
    this.state.cart_history_loading = toggle;
  }

  UPD_ALL_SELECTED_CARTS_HISTORY(value: boolean) {
    this.state.history_carts_list = this.state.history_carts_list.map((item: CartHistoryItem) => ({
      ...item,
      selected: value,
    }));
  }

  UPD_SELECTED_CARTS_HISTORY({ item, value }: { item: CartHistoryItem, value: boolean }) {
    if (!item) {
      return;
    }

    this.state.history_carts_list = this.state.history_carts_list.map((order) =>
      (order.id === item.id ? { ...order, selected: value } : order));
  }
}
